export const BAD_QUOTE_REVISION = 114;
